    import {Workbox} from 'workbox-window'

    let wb

    if ('serviceWorker' in navigator) {
      wb = new Workbox(`${process.env.BASE_URL}service-worker.js?${process.env.VUE_APP_APP_VERSION}`)
      wb.addEventListener('controlling', () => {
        // window.location.reload()
      })
      wb.register().then(() => {
        console.log('service worker registered')
      }).catch(error => {
        console.log('ServiceWorker registration failed:', error)
      })
    } else {
      wb = null
    }

    export default wb
